export default "/staticreactui/static/media/static/media/customer6.d16bf86f.webp";